import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';
import styles from './CookieBanner.module.css';

interface CookieBannerProps {
  visible: boolean;
  onAcceptAll: () => void;
  onAcceptEssential: () => void;
}

export default function CookieBanner({ visible, onAcceptAll, onAcceptEssential }: CookieBannerProps) {
  const { t } = useTranslation('common');

  if (!visible) return null;

  return (
    <div className={styles.banner} role="region" aria-label={t('cookieBanner.ariaLabel')}>
      <p className={styles.text}>
        {t('cookieBanner.message')}{' '}
        <a href="/privacy-policy">{t('cookieBanner.privacyPolicy')}</a>
      </p>
      <div className={styles.actions}>
        <button type="button" className={styles.essentialBtn} onClick={onAcceptEssential}>
          {t('cookieBanner.essentialOnly')}
        </button>
        <Button variant="primary" size="md" onClick={onAcceptAll}>
          {t('cookieBanner.acceptAll')}
        </Button>
      </div>
    </div>
  );
}
